import shortName from '@js/config/short-name'
import HS from 'heroes_share'

const { unitShortName } = shortName

function formatCombatData (d) {
  if (d.stacks) {
    d.stacks = d.stacks.map((stack) => {
      const result = {}
      for (let key in stack) {
        if (stack.hasOwnProperty(key)) {
          result[unitShortName[key] || key] = stack[key]
        }
      }
      return result
    })
  }
  if (d.deadStacks) {
    d.deadStacks = d.deadStacks.map((stack) => {
      const result = {}
      for (let key in stack) {
        if (stack.hasOwnProperty(key)) {
          result[unitShortName[key] || key] = stack[key]
        }
      }
      return result
    })
  }
}

const getDefaultState = () => {
  return {
    // 战斗
    initData: {},
    combatData: {},
    spells: [],
    battleLog: [],
    combatHistory: [],
    selectedSpell: null,
    selectedSpellTarget: null,
    isPlayingAnimation: false,
    isBattleStart: false,
    isBattleAudioEnd: false,
    isAutoCombat: false,
  }
}

const state = getDefaultState()

const getters = {
  initData (state) {
    return state.initData || {}
  },
  initMeta (state) {
    return state.initData?.meta
  },
  battleMapSize (state) {
    return state.initData.battleMapSize || {}
  },
  spells (state) {
    return state.initData.spells || []
  },

  combatData (state) {
    return state.combatData || {}
  },
  stacks (state) {
    return (state.combatData || {})?.stacks || []
  },
  mapModel (state) {
    return state.combatData.mapModel || ''
  },
  teams (state) {
    return state.combatData.teams || []
  },
  yourTurn (state, getters) {
    return state.isBattleStart && state.combatData.stacks?.[0]?.playerId === getters.player.id
  },
  players (state) {
    return state.combatData.teams?.map((t) => {
      return t.players
    }).flat() || []
  },
  player (state, getters, rootState) {
    const userInfo = rootState.user.userInfo
    return getters.players.find((p) => p.userId === userInfo.id) || {}
  },
  isPlayer (state, getters, rootState) {
    const userInfo = rootState.user.userInfo
    return getters.players.some((p) => {
      return p.userId === userInfo.id
    })
  },
  isPVP (state, getters) {
    return getters.teams.every((t) => {
      return t.players.some((p) => !p.isAI)
    })
  },
  inActionStack (state) {
    return (state.combatData?.stacks || [])[0]
  },

  selectedSpell (state) {
    return state.selectedSpell
  },
  selectedSpellTarget (state) {
    return state.selectedSpellTarget
  },
  isPlayingAnimation (state) {
    return state.isPlayingAnimation
  },
  isBattleAudioEnd (state) {
    return state.isBattleAudioEnd
  },
}

const actions = {
  // 初始化战斗数据
  initCombatData ({ commit, dispatch, state }, combatData) {
    commit('resetBattle')
    // console.log('[initCombatData]', !state.combatData, state.combatData.round < combatData.round)
    if (!state.combatData?.round || state.combatData.round < combatData.round) {
      commit('addBattleLog', `回合 ${(combatData?.round || 1)}`)
    }

    const d = JSON.parse(JSON.stringify(combatData))
    formatCombatData(d)

    commit('updateInitData', JSON.parse(JSON.stringify(d)))
    commit('updateCombatData', d)
    dispatch('updateMapModel')
  },

  // diff 后更新数据
  updateCombatData ({ commit, state, dispatch }, combatData) {
    if (!state.combatData || state.combatData.round < combatData.round) {
      commit('addBattleLog', `回合 ${combatData?.round || 1}`)
    }
    const d = JSON.parse(JSON.stringify(combatData))
    formatCombatData(d)
    const updateData = Object.assign({}, state.combatData, d)
    log.gray('[updateCombatData]', updateData)

    commit('updateCombatData', updateData)
    dispatch('updateMapModel')
  },

  // 更新战场数据模型
  updateMapModel ({ commit, state, getters }) {
    const mapModel = HS.battleMap.updateMapModel({
      stacks: state.combatData.stacks,
      obstacles: state.combatData.obstacles,
      size: getters.battleMapSize,
      simplify: true
    })
    const updateData = Object.assign({}, state.combatData, { mapModel })
    commit('updateCombatData', updateData)
  },

  // 设置选中的法术
  setSelectedSpell ({ commit }, spell) {
    commit('setSelectedSpell', spell)
  },
  // 设置施法对象
  setSelectedSpellTarget ({ commit }, target) {
    commit('setSelectedSpellTarget', target)
  },
  // 设置是否渲染动画中
  setIsPlayingAnimation ({ commit }, bl) {
    commit('setIsPlayingAnimation', bl)
  },
}

const mutations = {
  resetBattle (state) {
    Object.assign(state, getDefaultState())
  },

  addBattleLog (state, log) {
    state.battleLog.push(...log.split(/[\r\n]g/))
  },

  updateInitData (state, combatData) {
    state.initData = combatData
  },

  updateCombatData (state, combatData) {
    state.combatData = combatData
  },

  setSelectedSpell (state, spell) {
    state.selectedSpell = spell
  },

  setSelectedSpellTarget (state, target) {
    state.selectedSpellTarget = target
  },

  setIsPlayingAnimation (state, bl) {
    state.isPlayingAnimation = bl
  },

  setIsBattleStart (state, bl) {
    state.isBattleStart = bl
  },

  setIsBattleAudioEnd (state, bl) {
    state.isBattleAudioEnd = bl
  },

  setAutoCombat (state, bl) {
    state.isAutoCombat = bl
  },
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
